export default __webpack_public_path__ + "static/media/delete.c3960f04.svg";